import templateStr from 'text!./templates/yes-no-group.html';

export default [function () {
    return {
        restrict: 'AE',
        template: templateStr,
        scope: {
            label: '@',
            model: '=',
            isDisabled: '&'
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/inputs/YesNoGroup.js
// module id = 1977
// module chunks = 0